import React from "react";

export interface ButtonProps {
  /** The id of the button */
  id: string;

  /** The form name fields of the button */
  name?: string;

  /** The class(es) applied to the button */
  cssClass: string;

  /** The button title or text */
  text: string;

  icon?: JSX.Element;

  /** The click event handler of the button */
  onClick: Function;

  visible?: boolean;
  disabled?: boolean;
  isBusy?: boolean;
}

/** The base button component to be used on all pages depending on the style of the css */
export default class Button extends React.Component<ButtonProps> {
  _classNames: string;

  constructor(props: ButtonProps) {
    super(props);
    this.state = {
      isBusy: false,
    };
    this._classNames = props.cssClass ? props.cssClass : "btn btn-primary";
  }

  render(): React.ReactNode {
    return (
      <button
        id={this.props.id}
        name={this.props.name}
        disabled={this.props.disabled}
        className={this._classNames}
        onClick={(e) => {
          if (this.props.onClick !== undefined) {
            this.props.onClick();
          }
        }}
      >
        {!this.props.icon && this.props.isBusy && (
          <span
            className="spinner-border spinner-border-sm spinner-grow-sm"
            style={{ width: "1rem" }}
            role="status"
            aria-hidden="true"
          ></span>
        )}

        {this.props.icon}
        <span className="m-2">{this.props.text}</span>
      </button>
    );
  }
}
